import { Box, Button } from "@seneca/senekit";

import { LogInLink } from "features/sign-up/common-routes/components/form";
import SignInOptionsCard from "features/sign-up/sign-in-form/components/SignInCard/components/apps/SignInCardStandard/components/SignInOptionsCard";
import { RenderSignInFormProps } from "features/sign-up/sign-in-form/components/SignInCard/components/SignInCardCommon";

import SignUpFormButtons from "../../SignUpFormButtons";
import { SignUpOptionsCardHeader } from "../SignUpHeaders";

type Props = RenderSignInFormProps & {
  accountType?: string;
  linkToSignIn: string;
  onClickSignUpWithEmailLink: () => void;
  linkToNextPage?: string;
  linkToNextPageSSO?: string;
};

export default function SignUpOptionsCard(props: Props) {
  return (
    <Box
      dataTest="SignUpFormWrapper"
      paddingTop={["xlarge", "none"]}
      height="100%"
    >
      <SignInOptionsCard {...props}>
        {{
          header: (
            <SignUpOptionsCardHeader headerMessage={props.headerMessage} />
          ),
          ssoButtons: (
            <SignUpFormButtons
              accountType={props.accountType}
              setErrorMessage={props.setErrorMessage}
              onSignInSuccess={props.onSignInSuccess}
              redirectAuthenticatedUserTo={props.redirectAuthenticatedUserTo}
              linkToNextPage={props.linkToNextPageSSO || props.linkToNextPage}
            />
          ),
          bottomLink: <LogInLink loginLink={props.linkToSignIn} />,
          emailButton: (
            <Button
              type="button"
              width="100%"
              onClick={props.onClickSignUpWithEmailLink}
            >
              Sign up with email
            </Button>
          )
        }}
      </SignInOptionsCard>
    </Box>
  );
}
